class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			'keyup',
			(evt) => evt.code === 'Escape' && this.close(),
		);
		this.listenClose();
		this.setHeaderCartIconAccessibility();
	}

	listenClose() {
		document
			.querySelector('.js-cart-drawer-overlay')
			.addEventListener('click', this.close.bind(this));
		[...document.querySelectorAll('.js-cart-drawer-close')].forEach((el) =>
			el.addEventListener('click', this.close.bind(this)),
		);
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector('#cart-icon-bubble');
		cartLink.setAttribute('role', 'button');
		cartLink.setAttribute('aria-haspopup', 'dialog');
		cartLink.addEventListener('click', (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener('keydown', (event) => {
			if (event.code.toUpperCase() === 'SPACE') {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) {
			// Ajout d'un evenement sur le document à chaque fois que le cart es open
			document.dispatchEvent(
				new CustomEvent('cart-drawer-opened', {bubbles: true}),
			);
		}
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add('animate', 'is-visible');
			document
				.querySelector('.js-cart-drawer-overlay')
				.classList.add('is-visible');
		});

		this.addEventListener(
			'transitionend',
			() => {
				const containerToTrapFocusOn = this.classList.contains('is-empty')
					? this.querySelector('.drawer__inner-empty')
					: document.getElementById('CartDrawer');
				const focusElement =
					this.querySelector('.drawer__inner') ||
					this.querySelector('.drawer__close');
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{once: true},
		);

		document.body.classList.add('overflow-hidden');
	}

	close() {
		this.classList.remove('is-visible');
		document
			.querySelector('.js-cart-drawer-overlay')
			.classList.remove('is-visible');

		removeTrapFocus(this.activeElement);
		document.body.classList.remove('overflow-hidden');
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute(
				'aria-controls',
				cartDrawerNote.nextElementSibling.id,
			);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute(
				'aria-expanded',
				!event.currentTarget.closest('details').hasAttribute('open'),
			);
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector('.drawer__inner').classList.contains('is-empty') &&
			this.querySelector('.drawer__inner').classList.remove('is-empty');
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);

			/* FIX for - SAME VARIANT HAVE 2 LINE ITEMS -

           ICI si on detect une erreur (allItemDataErrorEl) on crée un event qui va dechangé un update des properties de tout les line items
        */

			if (section.id === 'cart-drawer') {
				const allItemDataErrorEl = new DOMParser()
					.parseFromString(parsedState.sections[section.id], 'text/html')
					.querySelector('.js-cart-error-update-all-item-properties');
				if (allItemDataErrorEl) {
					document.dispatchEvent(
						new CustomEvent('cart-error', {
							bubbles: true,
							detail: {
								allItemDataErrorEl: allItemDataErrorEl,
							},
						}),
					);
				} else {
					sectionElement.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.id],
						section.selector,
					);
				}

				// Add MiniCardLoad event on datalayer at all AddToCard
				const miniCartLoadEl = new DOMParser()
					.parseFromString(parsedState.sections[section.id], 'text/html')
					.querySelector('.js-gtm-loaded-json');

				if (miniCartLoadEl) {
					const miniCartLoadObjet = JSON.parse(miniCartLoadEl.textContent);
					if (window.dataLayer != void 0) {
						window.dataLayer.push(miniCartLoadObjet);
					}
				}
			} else {
				sectionElement.innerHTML = this.getSectionInnerHTML(
					parsedState.sections[section.id],
					section.selector,
				);
			}
		});

		setTimeout(() => {
			this.listenClose();
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'cart-drawer',
				selector: '#CartDrawer',
			},
			{
				id: 'cart-icon-bubble',
			},
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__inner',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);
